//--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
 

import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod
 const ConsumeEpimProductQueueForKafka=()=>request({
  url: ApiURL.Query.ConsumeEpimProductQueueForKafka,
  method: RequestType.GET,
 });

 const ProduceEpimProductToSyncQueue=()=>request({
  url: ApiURL.Query.ProduceEpimProductToSyncQueue,
  method: RequestType.GET,
 });
 
const ProductTransferQuery = {
  ConsumeEpimProductQueueForKafka,
  ProduceEpimProductToSyncQueue
};

export default ProductTransferQuery;
